import { memo } from 'react';
import { Button, Modal } from 'antd';
import IntlMessages from '../Message/IntlMessages';
import DangerousMessage from '../Message/DangerousMessage'

const AcceptRiskDesc = ({
  code, close, state, actions, ...modalProps
}) => {

  
  function _onAccept() {
    close();
    actions?.onAccept && actions.onAccept(code);
  }

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }


  return (
    <Modal {...modalProps} maskClosable={false} onCancel={close}>
    {modalProps.visible && (
      <div className="mnc-modal-disclaimer" >
        <div className="modal-mnc-head">
          <h5 className="m-0">
            <IntlMessages id="modal.riskDesc.header" />
          </h5>
          <Button className="btn button-ktb-close" onClick={_onCancel}>
            <i className="feather-icon icon-x"></i>
          </Button>
        </div>
        <div className="modal-mnc-body" style={{
                whiteSpace: "pre-wrap",
                maxHeight: "800px",
                overflowY: "scroll",
              }} >
          <p>
            <IntlMessages id={"model.riskDesc.title"} />
          </p>
          <div className="modal-remark p-3 overflow-x-hidden">
            <div
              style={{
                whiteSpace: "pre-wrap",
                maxHeight: "200px",
                overflowY: "scroll",
              }}
            >
              <DangerousMessage.Span className="custom-message-1" html={state.riskDesc}/>
            </div>
          </div>
        </div>
        <div className="modal-mnc-footer">
          <div className="row justify-content-center">
            <div className="col-6 pe-1 pe-md-2">
              <div className="d-grid">
                <Button
                  data-logout-btn
                  className="btn button-ktb-line"
                  onClick={_onCancel}
                >
                  <IntlMessages id="global.back" />
                </Button>
              </div>
            </div>
            <div className="col-6 ps-1 ps-md-2">
              <div className="d-grid">
                <Button
                  data-accept-btn
                  className="btn button-ktb-main"
                  onClick={_onAccept}
                >
                  <IntlMessages id="global.acknowledge" />
                  <i className="feather-icon icon-chevron-right ms-1"></i>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </Modal>
  )
}

export default memo(AcceptRiskDesc);